import { useCallback } from 'react';

import { useResetRecoilState } from 'recoil';

import { automaticDebitData } from '../pages/PaymentLink/components/PaymentContent/AutomaticDebit/store/atoms/automaticDebitData';
import { nupayData } from '../pages/PaymentLink/components/PaymentContent/Nupay/store/atoms/nupayData';
import { pixData } from '../pages/PaymentLink/components/PaymentContent/Pix/store/atoms/pixData';
import { acceptedAccessionTermsAtom } from '../store/AccessionTerms/atoms/acceptedAccessionTerms';
import { isDocumentAuthenticated } from '../store/isDocumentAuthenticated/atoms/isDocumentAuthenticated';
import { paymentMethodChangeAcceptance } from '../store/PaymentMethodChangeAcceptance/atoms/paymentMethodChangeAcceptance';

/**
 * Devolve ao padrão o que é de um orçamento só.
 *
 * Esses dados moram em atoms globais do Recoil, que vivem a sessão inteira do SPA. No link
 * isso nunca apareceu, porque cada link é um carregamento novo de página. Vindo do
 * carrinho o cliente compra, volta para a loja e compra de novo sem recarregar nada — a
 * segunda compra abriria com o QR code da primeira, o botão de gerar desabilitado, o termo
 * de adesão marcado sem aceite para o contrato novo e o documento já dado por autenticado.
 *
 * Fica de fora o que é do cliente, e não da compra: o documento do responsável confirmado
 * e o motivo de bloqueio do responsável seguem valendo entre orçamentos do mesmo cliente,
 * como já valiam.
 *
 * Quem chama é responsável por só limpar quando o orçamento muda: limpar a cada montagem
 * apagaria uma cobrança Pix já gerada no mesmo checkout.
 */
export default function useResetCheckoutState() {
  const resetPixData = useResetRecoilState(pixData);
  const resetNupayData = useResetRecoilState(nupayData);
  const resetAutomaticDebitData = useResetRecoilState(automaticDebitData);
  const resetAcceptedAccessionTerms = useResetRecoilState(
    acceptedAccessionTermsAtom,
  );
  const resetIsDocumentAuthenticated = useResetRecoilState(
    isDocumentAuthenticated,
  );
  const resetPaymentMethodChangeAcceptance = useResetRecoilState(
    paymentMethodChangeAcceptance,
  );

  return useCallback(() => {
    resetPixData();
    resetNupayData();
    resetAutomaticDebitData();
    resetAcceptedAccessionTerms();
    resetIsDocumentAuthenticated();
    resetPaymentMethodChangeAcceptance();
  }, [
    resetPixData,
    resetNupayData,
    resetAutomaticDebitData,
    resetAcceptedAccessionTerms,
    resetIsDocumentAuthenticated,
    resetPaymentMethodChangeAcceptance,
  ]);
}
